<template>
  <div class="form-group">
    <label class="form-item has-label"
      v-bind:class="{'has-error': errors.has(field.key)}">
      <small class="label" v-html="sanitizedFieldTitle">
        {{ field.title }}
      </small>
      <input type="tel"
        class="form-control"
        autocomplete="tel"
        v-bind:name="field.key"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-validate="validationRules"
        v-bind:data-vv-as="strippedFieldTitle"
        tabindex="1">
    </label>
    <small class="form-help-text" v-html="sanitizedHelpText"></small>
    <span class="invalid-feedback"
      v-if="errors.has(field.key)">
      {{ errors.first(field.key) }}
    </span>
  </div>
</template>

<script>
import InputMixin from '@/mixins/InputMixin';

/**
 * Input Phone
 * -- Implements v-model
 *
 * A field that renders a phone input.
 */
export default {
  name: 'InputPhone',
  mixins: [
    InputMixin,
  ],
};
</script>
